import { Moon, Sun } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useTheme } from '@/components/ui/theme-provider';
import { iconSize } from '@/theme/size-tokens';

export type ColorModeToggleProps = {
  className?: string;
};

function ColorModeToggle({ className = '' }: Readonly<ColorModeToggleProps>) {
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  const isDark = theme === 'dark';
  const label = `Switch to ${theme === 'light' ? 'dark' : 'light'} theme`;
  const Icon = isDark ? Moon : Sun;

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className={className}
      aria-label={label}
    >
      <Icon className={iconSize('md')} />
    </Button>
  );
}

export { ColorModeToggle };
export default ColorModeToggle;
